module.exports = __webpack_public_path__ + "img/line-b.54adedd8.png";